import DOMPurify from 'dompurify';

// Used to neutralize <script>, event handler attributes (onerror, onload, ...),
// javascript: URIs, <iframe>/<object>/<embed>, etc. before user-authored HTML
// (from the text/MJML block editors) reaches dangerouslySetInnerHTML or is
// embedded into generated HTML/MJML output.
export const sanitizeHtml = (html, config) => {
  if (!html) return html;
  return DOMPurify.sanitize(html, config);
};

// For full <html>...</html> documents (e.g. compiled MJML output). Without
// WHOLE_DOCUMENT, DOMPurify treats input as a body fragment and strips
// <head>/<style>/<meta>, which would break the exported email's markup.
export const sanitizeHtmlDocument = (html) =>
  sanitizeHtml(html, { WHOLE_DOCUMENT: true });
